import { render, staticRenderFns } from "./SaleDetailApartmentPage.vue?vue&type=template&id=61ac17d5&"
import script from "./SaleDetailApartmentPage.vue?vue&type=script&lang=js&"
export * from "./SaleDetailApartmentPage.vue?vue&type=script&lang=js&"
import style0 from "./SaleDetailApartmentPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports